/**
 * © 2025 Indikin.online. All rights reserved.
 * Made with ❤️ by YalaCoder.
 *
 * Custom Hook for Guest User Context
 *
 * --- REWRITE SUMMARY (Linter Fix) ---
 * - MISSION: To resolve the `react-refresh/only-export-components` ESLint
 * error by ensuring the hook imports the context from the correct,
 * component-free file.
 *
 * - THE FIX (Corrected Import Path):
 * 1.  The import path for `GuestUserContext` has been updated from
 * `'@/context/GuestUserContext.jsx'` to `'@/context/guestUser.context.js'`.
 *
 * - RESULT: This final change completes the linter-related refactor. The
 * hook now consumes the context from the correct location, ensuring a
 * stable and error-free development experience.
 */
import { useContext } from 'react';
import { GuestUserContext } from '@/context/guestUser.context.js'; // <-- FIX: Import context

export const useGuestUser = () => {
  const context = useContext(GuestUserContext);
  if (context === undefined) {
    // This error is crucial for debugging, ensuring the hook is used correctly.
    throw new Error('useGuestUser must be used within a GuestUserProvider');
  }
  return context;
};

